var render = function (_h,_vm) {var _c=_vm._c;return (_vm.props.val)?_c('span',{class:_vm.props.val < 0?'red':'black'},[_vm._v("\n    £"+_vm._s(Number((parseFloat(_vm.props.val)/1000000).toFixed(1)).toLocaleString('en-US'))+"M\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }